var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMemAuthenticated)?_c('MemberProfile'):_vm._e(),(!_vm.isMemAuthenticated)?_c('div',{staticClass:"d-flex justify-content-center mb-3 mt-32"},[_c('memlist-spinner')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }